import {
  Attribute,
  Component,
  Injector,
  Optional, ViewChild
} from '@angular/core';
import {CommonModule} from "@angular/common";

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";
import {SearchComponent} from "../../basic/search/search.component";
import {DatasetAwareComponent} from "../dataset-aware.component";
import {forEach, isEqual, isObject, toString, values, find, startsWith} from "lodash-es";
import {runtimeEventManager} from "@wm/core";

const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-chips',
  hostClass: 'app-chips nav nav-pills list-inline',
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmChips]',
  template: `
    <li class="chip-item {{chipclass && !bindChipclass ? chipclass : ''}}" role="option" *ngFor="let item of chipsList; let $index = index;">
      <a class="app-chip" href="javascript:void(0);" tabindex="-1">
        <img data-identifier="img" alt="Chip Image" class="button-image-icon" [src]="item.imgSrc" *ngIf="item.imgSrc"/>
        <span class="app-chip-title" [textContent]="item.label" [title]="item.label"></span>
        <button type="button" tabindex="-1" aria-label="Clear Button" class="btn btn-transparent" *ngIf="!readonly">
          <i class="app-icon wi wi-close"></i>
        </button>
      </a>
    </li>

    <li class="app-chip-search" [ngClass]="{'full-width': inputwidth === 'full'}">
    <div *ngIf="!isWidgetInsideCanvas" #search wmSearch class="app-chip-input"
         name="app-chip-search"
         submit.event="addItem($event, widget)"
         beforeservicecall.event="invokeOnBeforeServiceCall(inputData)"
         disabled.bind="disabled || readonly || saturate"
         datafield.bind="datafield"
         allowonlyselect.bind="allowonlyselect"
         searchkey.bind="searchkey"
         orderby.bind="orderby"
         placeholder.bind="saturate ? maxSizeReached : placeholder"
         showsearchicon.bind="showsearchicon"
         tabindex.bind="tabindex"
         minchars.bind="minchars"
         debouncetime.bind="debouncetime"
         datacompletemsg.bind = "datacompletemsg"
         matchmode.bind="matchmode"
         groupby.bind="groupby"
         match.bind="match"
         dateformat.bind="dateformat">
    </div>
    <input type="text" class="form-control" *ngIf="isWidgetInsideCanvas" [placeholder]="placeholder">
  </li>`,
  providers: [
    provideAsWidgetRef(ChipsComponent)
  ],
  exportAs: 'wmChips',
  standalone: true,
  imports: [CommonModule, SearchComponent],
  styles: []
})
export class ChipsComponent extends DatasetAwareComponent {
  static initializeProps = register('wm-chips');

  public allowonlyselect: boolean;
  public enablereorder: boolean;
  public maxsize: number;
  public inputwidth: any;
  public placeholder: string;
  public isWidgetInsideCanvas: boolean = true;
  public chipsList: Array<any> = [];
  public chipclass: string;
  public bindChipclass: string;
  private liveWidgetUtils: any;
  private baseVariable: any;

  constructor(inj: Injector,
              @Optional() viewParent: Parent,
              @Attribute('dataset.bind') private bindDataSet: any) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
    this.liveWidgetUtils = runtimeEventManager.getService('LiveWidgetUtilsService');
    this.baseVariable = runtimeEventManager.getService('variableService');
  }

  protected override onPropertyChange(key: string, nv: any, ov?: any) {
    switch (key) {
      case 'dataset':
        this.updateMatchModeAttr();
        break
      case 'datavalue':
        this.chipsList = []
        nv = nv.split(',')
        nv.forEach((val:any) =>{
          const itemFound = find(this.datasetItems, item => {
            return isObject(item.value) ? isEqual(item.value, val) : toString(item.value) === toString(val);
          });
          if (itemFound) {
            this.chipsList.push(itemFound);
          }
        })
        break;
    }
    super.onPropertyChange(key, nv, ov);
  }

  updateMatchModeAttr() {
    let isBoundToVariable = startsWith(this.binddataset, 'bind:Variables.');
    if (isBoundToVariable) {
      let variable = this.baseVariable.getVariableByName(this.binddataset.split('.')[1]);
      let matchmodeAttr = this.nativeElement.getAttribute('matchmode');

      if (variable && variable.category === 'wm.LiveVariable') {
        // set default matchmode when no value is set.
        if (!matchmodeAttr) {
          runtimeEventManager.emit('set-markup-attr', {widgetId: this.widgetId, 'matchmode': 'startignorecase'});
        }
      } else if (!matchmodeAttr) {
        runtimeEventManager.emit('set-markup-attr', {widgetId: this.widgetId, 'matchmode': ''})
      }
    }
  }

  getCustomizedOptions(name: any, fields: any){
    return this.liveWidgetUtils.getCustomizedOptions(this, name, fields);
  }
}

